import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client';

let socket = null;
let stompClient = null;
let isConnected = false;
let prefixUrl = '';

const disconnect = () => {
    if (stompClient) {
        stompClient.disconnect();
    }
    socket = null;
    stompClient = null;
    prefixUrl = '';
    isConnected = false;
};

const connect = async () => {
    if (isConnected) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        socket = new SockJS(
            window.location.origin + process.env.VUE_APP_HTTP_PATH + '/ws',
            [],
            {}
        );
        stompClient = Stomp.over(socket);

        if (process.env.NODE_ENV !== 'development') {
            stompClient.debug = () => {};
        }

        stompClient.connect(
            {
                Cookie: document.cookie
            },
            () => {
                prefixUrl = `/user/`;
                isConnected = true;
                resolve();
            },
            err => {
                disconnect();
                reject(err);
            }
        );
    });
};

const subscribe = (subscription, callback) => {
    if (!isConnected) {
        return;
    }

    waitForSocketConnection(stompClient.ws, function () {
        return stompClient.subscribe(prefixUrl + subscription, response => {
            if (typeof callback !== 'function') {
                return;
            }

            callback(response.body);
        });
    });
};

function waitForSocketConnection(socket, callback) {
    setTimeout(function () {
        if (socket.readyState === 1) {
            if (callback != null) {
                callback();
            }
        } else {
            waitForSocketConnection(socket, callback);
        }
    }, 5);
}

export { connect, disconnect, subscribe };
